// extracted by mini-css-extract-plugin
export default {"lessontitle":"newgame_lessontitle__um5PX"};